import * as React from 'react';
import { FC } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { useRecordContext, UseRecordContextParams } from 'react-admin';
import { stringify } from 'query-string';
import { Badge } from '@material-ui/core';
import get from 'lodash/get';
import { r2PaletteColors } from '../layout/themes'

const useStyles = makeStyles(theme => ({
    icon: {},
    label: { paddingLeft: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    badge: {
        right: -3,
        top: 13,
        border: `2px solid ${theme.palette.background.default}`,
        padding: '0 4px',
    },
    rootBadge: (props: any) => {
        const colors = Object.values(r2PaletteColors)
        return props.getColor ? {
            color: props.record.data?.color ?
                props.record.data?.color : colors[(props.record.id - 1) % colors.length]
        } : {}
    }
}))

// useful to prevent click bubbling in a datagrid with rowClick
const stopPropagation: React.MouseEventHandler<HTMLAnchorElement> = e => e.stopPropagation();

const BadgeToRelated: FC<UseRecordContextParams> = (props) => {

    const { getColor = false } = props
    const record = useRecordContext(props);

    const classes = useStyles({ ...props, getColor });

    return (
        <Button
            size="small"
            color="primary"
            component={Link}
            to={{
                pathname: props.reference,
                search: stringify({
                    filter: JSON.stringify({ [props.target]: record?.id }),
                }),
            }}
            className={classes.link}
            onClick={stopPropagation}
        >
            <Badge
                badgeContent={get(record, props.source) || "0"}
                color="primary"
                max={9999}
                classes={{
                    root: classes.rootBadge,
                    badge: classes.badge,
                }}
            >
                <props.icon />
            </Badge>
        </Button >
    );
};

export default BadgeToRelated;
